import { useLocation } from "react-router-dom";
import ChatWidget from "./ChatWidget";

export default function ChatWidgetWrapper() {
  const {pathname} = useLocation() || "/";
  const path = pathname.toLowerCase();

  // pages where the chat widget should NOT appear
  const excludedPaths = [
    "/chat",
    "/sign-in",
    "/sign-up",
    "/done",
    "/registration",
    "/dashboard",
    "/analytics",
    "/reports",
    "register-admin"
    
  ];

  // hide on exact matches or when the current path is a child of an excluded
  const isExcluded = excludedPaths.some(
    (p) => path === p || path.startsWith(p + "/")
  );

  if (isExcluded) return null;

  return <ChatWidget />;
}
